import type { Prototype } from "../prototype-types";

/**
 * Your workspace on `/workspaces/uzair` is built from this list.
 * Add a new object for each prototype you want to show up there (in addition
 * to registering the route in App.tsx and lazy routes).
 */
export const uzairAshrafPrototypes: Prototype[] = [
  {
    id: "all-categories-promoted",
    name: "All categories — promoted column",
    path: "/ua/all-categories-promoted",
    description:
      "RetailerLayout with a sponsored / editorial column in the desktop All categories mega-menu (open All categories in the top nav to preview).",
    owner: "Uzair Ashraf",
    createdAt: "2026-04-24",
    lastUpdated: "2026-04-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/0bb4843dee7cdfb3209e4cedc686dfa6dae348de0e3ccd35e22aa6d2ba8c2531.png",
    creationTool: "cursor",
  },
  {
    id: "search-ads-inline-carousel",
    name: "Search Ads Grid",
    path: "/ua/search-ads-grid",
    description:
      "Search product grid with an inline promoted (ads shop) carousel: horizontal scroll, arrow controls, and keyboard on the scroller, aligned in the grid with other tiles.",
    owner: "Uzair Ashraf",
    createdAt: "2026-04-17",
    lastUpdated: "2026-04-22",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/eb9844f9ad15d18116594397bcdac57e1c7285f4eac79dbc2cf2f1dcb007a333.png",
    creationTool: "cursor",
  },
  {
    id: "search-popout-carousels",
    name: "Sponsored popout carousels",
    path: "/ua/search-popout-carousels",
    description:
      "Search results with five interactable sponsored placements: full-width row interrupt, bottom pop-out brand tray, inline 2×3 group, sticky brand rail, and expand-in-place ribbon. Use the variant switcher to compare.",
    owner: "Uzair Ashraf",
    createdAt: "2026-04-24",
    lastUpdated: "2026-04-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/cd1e7913d060751f54d7f47d4e4542695175e791c7e180537618ebd02c66df69.png",
    creationTool: "cursor",
  },
];
